<template>
  <div class="mc-trackvideo-card--novideo">
    <div class="mc-trackvideo__wrapper-no-video">
      <img :src="getAsset('secondaryLogo', 'sidebarMinimize')" />
      <p>{{ $t('trackVideo.state.noVideo') }}</p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
  },
}
</script>
